export const es_info= {
    title: 'Info utili',
    title_auction: 'Recursos',
    borsino_value: 'Valore borsino immobiliare',
    immobiliare_it: 'Valore quotazione immobiliare.it',
    real_estate: 'Agenzia',
    real_estate_agent: 'Agente'
};